module.exports = __webpack_public_path__ + "img/departamento-white.0f57898f.svg";